module.exports = __webpack_public_path__ + "img/letter-result-bg.d272ec7a.png";